import { useEffect, useState } from "react";

const DEFAULT_STATS = [
  { value: "20+", label: "Districts", icon: "🗺️" },
  { value: "100+", label: "Active Listings", icon: "🏠" },
  { value: "500+", label: "Happy Clients", icon: "⭐" },
  { value: "100%", label: "Verified", icon: "✔" }
];

export default function Footer() {
  const [stats, setStats] = useState(DEFAULT_STATS);

  useEffect(() => {
    const onStatsUpdate = (event) => {
      if (Array.isArray(event?.detail?.stats) && event.detail.stats.length) {
        setStats(event.detail.stats);
      }
    };
    window.addEventListener("fy-stats-update", onStatsUpdate);
    return () => window.removeEventListener("fy-stats-update", onStatsUpdate);
  }, []);

  return (
    <footer className="fy-footer fy-standalone-footer">
      <div className="fy-footer-stats">
        {stats.map((item) => (
          <div key={item.label} className="fy-footer-stat-item">
            <div className="fy-footer-stat-value">
              {item.icon} {item.value}
            </div>
            <div className="fy-footer-stat-label">{item.label}</div>
          </div>
        ))}
      </div>
      <div className="fy-footer-inner">
        <h4>FutureYard</h4>
        <p>Jammu &amp; Kashmir&apos;s trusted property marketplace</p>
        <p>📧 futryrd@gmail.com +91-9055500082</p>

        <small>© 2026 FutureYard. Designed and developed by moonage</small>
      </div>
    </footer>
  );
}
